import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import find from "lodash/find";
import { IoTime, IoCash } from "react-icons/io5";

import * as modalActions from "../../../actions/modalActions";
import * as contractActions from "../../../actions/contractActions";
import * as projectActions from "../../../actions/projectActions";
import * as callActions from "../../../actions/callActions";
import * as codeActions from "../../../actions/codeActions";

import PurchaseOrderList from "./PurchaseOrderList";
import PurchaseOrderForm from "./PurchaseOrderForm";
import ContractMetrics from "../ContractMetrics";
import HeaderWrapper from "../../common/HeaderWrapper";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";
import { customToast as toast } from "../../../utils";

class PurchaseOrderPage extends Component {
  constructor(props) {
    super(props);
    this.state = { purchaseOrder: {}, calls: [], hours: true };
  }

  componentDidMount = () => {
    const {
      match: { params },
      actions
    } = this.props;

    actions.getContract(params.id);
    actions.loadProjects({ contract: params.id });

    this.fetchCalls(params.id);
  };

  onClickToggle = () => {
    this.setState({ hours: !this.state.hours });
  };

  onClickAdd = () => {
    if (this.props.auth.maxRole < 4000) {
      toast.warning(
        `You do not have required access privileges to modify purchase orders.`
      );
    } else {
      this.setState({ purchaseOrder: {}, adding: true });
      this.props.actions.getContract(this.props.contract._id, true);
    }
  };

  onClickEdit = (purchaseOrder) => {
    if (this.props.auth.maxRole < 4000) {
      toast.warning(
        `You do not have required access privileges to modify purchase orders.`
      );
    } else {
      this.setState({ purchaseOrder, adding: false });
      this.props.actions.getContract(this.props.contract._id, true);
    }
  };

  onClickDelete = (poId) => {
    this.props.actions.requestPOId(poId, true);
  };

  // handleChangeRate = () => {
  //   const purchaseOrder = find(this.props.contract.purchase_orders, {
  //     id: this.props.contractPOToDelete
  //   });
  // };
  fetchCalls = async (id) => {
    const data = await this.props.actions.loadCalls({ contract: id });
    this.setState({ calls: data.calls });
  };

  handleAdd = async (contract, purchaseOrder) => {
    await this.props.actions.createPurchaseOrder(contract, purchaseOrder);
    await this.props.actions.getContract(contract.id);
    await this.props.actions.hideModal();
  };

  handleSave = async (contract, purchaseOrder) => {
    const data = {
      id: this.state.purchaseOrder.id,
      po_id: this.state.purchaseOrder.po_id,
      ...purchaseOrder
    };
    await this.props.actions.updatePurchaseOrder(contract, data);
    await this.props.actions.getContract(contract.id);
    await this.props.actions.hideModal();
  };

  handleDelete = async () => {
    const { contract } = this.props;
    const purchaseOrder = { id: this.props.contractPOToDelete };

    await this.props.actions.deletePurchaseOrder(contract, purchaseOrder);
    await this.props.actions.getContract(contract.id);
  };

  handleCancel = () => {
    this.props.actions.hideModal();
  };

  render() {
    const { contract, projects, savingContract, isMobile, auth } = this.props;
    const { purchaseOrder, calls, adding, hours } = this.state;

    const purchaseOrderForm = (
      <PurchaseOrderForm
        contract={contract}
        purchaseOrder={purchaseOrder || {}}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        saving={savingContract}
        editing
        adding={adding}
      />
    );

    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[
            { label: contract.name },
            { label: "Prepaid Purchases" }
          ]}
          // only allow add if billing admin, ceo, or admin
          onClickAdd={
            (auth.maxRole === 4000 || auth.maxRole >= 8000) && this.onClickAdd
          }
          onClickAction={[
            {
              action: this.onClickToggle,
              icon: hours ? <IoCash /> : <IoTime />,
              size: "lg"
            }
          ]}
          isMobile={isMobile}
        />
        <ContractMetrics
          contract={contract}
          projects={projects}
          calls={calls}
          hours={hours}
        />
        <div className="content-wrapper">
          <PurchaseOrderList
            contract={contract}
            isMobile={isMobile}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
        </div>
        <Modal
          id="contractDetailsModal"
          title={adding ? "Add Purchase Order" : "Edit Purchase Order"}
          body={purchaseOrderForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="purchaseOrderDeleteModal"
          title="Delete Project"
          body="Are you sure you want to delete this purchase order?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </React.Fragment>
    );
  }
}

PurchaseOrderPage.propTypes = {
  actions: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired,
  savingContract: PropTypes.bool,
  match: PropTypes.object,
  auth: PropTypes.object,
  contract: PropTypes.object,
  contractPOToDelete: PropTypes.object,
  isMobile: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    contract: state.reducers.contract,
    projects: state.reducers.projects,
    savingContract: state.reducers.savingContract,
    contractPOToDelete: state.reducers.contractPOToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...contractActions,
        ...projectActions,
        ...callActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(PurchaseOrderPage);
